import { addDocumentos } from "../../sec/ModalUploadDocs";

export const getDatosDoc = (tipo, dato) => {
    let datosDoc;
    if (tipo === "siniestrosGen") {
        datosDoc = {
            cdCompania: dato.cdCompania,
            cdReclamo: dato.cdReclamo,
            cdCliente: dato.cdCliente,
            cdIncapsiniestro: 0,
            tipo,
            zohoId: dato.zohoId || "",
            items: [addDocumentos()],
        };
    } else if (tipo === "siniestroVam") {
        datosDoc = {
            cdCompania: dato.cdCompania,
            cdReclamo: dato.cdReclamo,
            cdIncapsiniestro: dato.cdIncSiniestro,
            cdCliente: dato.cdCliente,
            tipo,
            zohoId: dato.zohoId || "",
            items: [addDocumentos()],
        };
    } else if (tipo === "poliza") {
        datosDoc = {
            cdCompania: dato.cdCompania,
            cdCotizacion: dato.cdCotizacion,
            cdCliente: dato.cdCliente,
            tipo,
            poliza: dato.poliza,
            anexo: dato.anexo,
            items: [addDocumentos()],
        };
    } else if (tipo === "vinculacion") {
        datosDoc = {
            cdCliente: dato,
            tipo,
            items: [addDocumentos()],
        };
    }
    return datosDoc;
};
